<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card" style="padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">发票基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="发票号码" prop="no">
                <el-input :disabled="!editMode" v-model="form.no" placeholder="请填写发票号码" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发票代码" prop="billCode">
                <el-input :disabled="!editMode" v-model="form.billCode" placeholder="请填写发票代码" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属科室" prop="ownerDeptName">
                <el-select :disabled="!editMode" v-model="form.ownerDeptName" style="width: 90%" filterable placeholder="请选择所属科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="发票类型" prop="type">
                <el-select :disabled="!editMode" v-model="form.type" placeholder="请选择发票类型" style="width: 90%">
                  <el-option v-for="item in InvoiceTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="category">
                <template v-if="buyOrSale == 0">
                  <el-select :disabled="!editMode" v-model="form.category" placeholder="请选择单据类型" style="width: 90%" @change="categoryChange">
                    <el-option v-for="item in BillTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select :disabled="!editMode" v-model="form.category" placeholder="请选择单据类型" style="width: 90%" @change="categoryChange">
                    <el-option v-for="item in BillTypeOptions2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开票总数量/金额">
                <SeparateInput class="billing" disabled :left="form.totalNumber" :right="form.totalAmount" :leftOption="{
                    min: 0,
                    precision: 2,
                    placeholder: '请填写开票数量',
                  }" :rightOption="{
                    precision: 4,
                    placeholder: '自动带出开票金额',
                  }" :autoCalculation="false" style="width: 90%"></SeparateInput>
                <!-- @change="(left, right) => ratioChange(form, left, right)" -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="待开票总数量/金额">
                <SeparateInput class="billing" disabled :left="form.unTotalNumber" :right="form.unTotalAmount" :leftOption="{
                    min: 0,
                    precision: 2,
                    placeholder: '自动带出开票数量',
                  }" :rightOption="{
                    precision: 4,
                    placeholder: '自动带出开票金额',
                  }" :autoCalculation="false" style="width: 90%"></SeparateInput>
                <!-- @change="(left, right) => ratioChange(form, left, right)" -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开票日期" prop="date">
                <el-date-picker v-model="form.date" :disabled="!editMode" type="date" placeholder="请选择开票日期" style="width: 90%" :picker-options="{
                    disabledDate(v) {
                      return disabledDateFun(v);
                    },
                  }">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="buyOrSale">
              <el-form-item label="开票人" prop="billUserName">
                <el-select :disabled="!editMode" v-model="form.billUserName" style="width: 90%" filterable placeholder="请选择盘点人" :filter-method="getUsers" @change="userChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="buyOrSale">
              <el-form-item label="所属科室" prop="billDeptName">
                <el-select :disabled="!editMode" v-model="form.billDeptName" style="width: 90%" filterable placeholder="请选择所属科室" :filter-method="getDepts" @change="billDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="厂商信息" prop="manufacturerName">
                <el-select :disabled="!editMode" v-model="form.manufacturerName" style="width: 90%" filterable clearable="" placeholder="请选择厂商信息" :filter-method="GetManufacturer" @change="manufacturerChange">
                  <el-option v-for="item in ManufacturerInfos" :key="item.type + '-' + item.id" :label="item.name" :value="item.type + '-' + item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传附件" prop="fileInfos"> </el-form-item>
              <UploadFileList :fileList="form.fileInfos" btnShowType="always" :showLabel="false" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">开票明细</span>
          </div>
          <div class="detail-header">
            <el-tabs v-model="detailShowType" @tab-click="handleClick" stretch style="width:260px">
              <el-tab-pane v-for="item in BillingDetailsTypeOptions" :key="item.id" :name="item.id">
                <template slot="label">
                  <span style="margin: 0 10px"> {{ item.name }} </span>
                </template>
              </el-tab-pane>
            </el-tabs>
            <div class="right">
              <div class="date-range-div" v-show="detailShowType == 0">
                <el-date-picker style="width:240px" v-model="uninvoicedQuery.dateRange" type="daterange" range-separator="至" start-placeholder="年/月/日" end-placeholder="年/月/日" @change="dateChange">
                </el-date-picker>
              </div>
              <div class="search" v-show="detailShowType == 0">
                <input class="search-input" type="text" v-model="uninvoicedQuery.keyWord" />
                <i class="el-icon-search padding10" @click="Query(false)"></i>
                <!-- <input type="text" v-model="query.keyWord"  /> -->
              </div>
              <el-button v-show="editMode" class="btn default" size="small" v-preventReClick @click="AddOrDelete">
                {{ detailShowType == 0 ? "新增已选" : "删除已选" }}
              </el-button>
            </div>
          </div>
          <el-table ref="unTable" border v-show="detailShowType == 0" :data="uninvoicedData" style="width: auto; margin: 0 10px" @select="handleChildRowChange" @select-all="handleChildSelectAll" stripe :header-cell-style="{ background: '#DDEBFF' }" :default-expand-all="true" :row-class-name="getRowClass">
            <el-table-column v-if="editMode" type="selection" fixed width="70" align="center" />
            <el-table-column type="expand">
              <template slot-scope="scope2" v-if="scope2.row.details">
                <el-table :ref="'towList' + scope2.row.id" border :data="scope2.row.details" class="two-list" stripe :header-cell-style="{ background: '#DDEBFF' }" :row-style="{ background: '#F9F9F9' }" @select="handleSonChildRowChange($event, scope2.row)" @select-all="handleSonChildSelectAll($event, scope2.row)">
                  <el-table-column :key="'untable' + timeStamp" v-if="editMode" type="selection" width="50" fixed align="center" />
                  <!-- :selectable="sSelectable" -->
                  <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="140" prop="assetName" />
                  <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="140" prop="specName" />
                  <el-table-column show-overflow-tooltip label="数量" align="center" min-width="140" prop="number" :formatter="toDecimal2" />
                  <el-table-column show-overflow-tooltip label="单价" align="center" min-width="140" prop="price" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="金额" align="center" min-width="140" prop="amount" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="税率" align="center" min-width="140" prop="taxRate">
                    <template slot-scope="sScope">
                      {{ sScope.row.taxRate }}%
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="税额" align="center" min-width="140" prop="taxAmount" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="开票数量/金额" align="center" min-width="200">
                    <template slot-scope="sScope">
                      {{ toDecimal2("", "", sScope.row.billNumber) }}/{{
                        toDecimalNo4("", "", sScope.row.billAmount)
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="待开票数量/金额" align="center" min-width="140">
                    <template slot-scope="sScope">
                      {{ toDecimal2("", "", sScope.row.unBillNumber) }}/{{
                        toDecimalNo4("", "", sScope.row.unBillAmount)
                      }}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>

            <!-- :selectable="pSelectable" -->
            <el-table-column show-overflow-tooltip label="单号" align="center" min-width="180" prop="no" />
            <el-table-column show-overflow-tooltip label="库房/科室" align="center" min-width="130" prop="fixedAssetName">
              <template slot-scope="scope">
                {{ scope.row.warehouseName }}{{ scope.row.stockDeptName }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="创建时间" align="center" min-width="130" prop="createdTime">
              <template slot-scope="scope">
                <div>
                  {{
                    parseTime(new Date(scope.row.createdTime), "{y}:{m}:{d}")
                  }}
                </div>
                <div>
                  {{
                    parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}")
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="数量" align="center" min-width="140" prop="billNumber" :formatter="toDecimal2" />
            <el-table-column show-overflow-tooltip label="待开票数量" align="center" min-width="140" prop="unBillNumber" :formatter="toDecimal2" />
            <el-table-column show-overflow-tooltip label="金额" align="center" min-width="140" prop="billAmount" :formatter="toDecimal4" />
            <el-table-column show-overflow-tooltip label="待开票金额" align="center" min-width="140" prop="unBillAmount" :formatter="toDecimal4" />
          </el-table>
          <el-table ref="inTable" border v-show="detailShowType != 0" :data="ininvoicedData" style="width: auto; margin: 0 10px" @select="handleChildRowChangeS" @select-all="handleChildSelectAllS" stripe :header-cell-style="{ background: '#DDEBFF' }" :default-expand-all="true" :row-class-name="getRowClass">
            <el-table-column v-if="editMode" type="selection" fixed width="70" align="center" />
            <el-table-column type="expand">
              <template slot-scope="scope2" v-if="scope2.row.details">
                <el-table :ref="'towList2' + scope2.row.id" border :data="scope2.row.details" class="two-list" stripe :header-cell-style="{ background: '#DDEBFF' }" :row-style="{ background: '#F9F9F9' }" @select="handleSonChildRowChangeS($event, scope2.row)" @select-all="handleSonChildSelectAllS($event, scope2.row)">
                  <el-table-column v-if="editMode" type="selection" fixed width="50" align="center" />
                  <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="140" prop="assetName" />
                  <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="140" prop="specName" />
                  <el-table-column show-overflow-tooltip label="数量" align="center" min-width="140" prop="number" :formatter="toDecimal2" />
                  <el-table-column show-overflow-tooltip label="单价" align="center" min-width="140" prop="price" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="金额" align="center" min-width="140" prop="amount" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="税率" align="center" min-width="140" prop="taxRate">
                    <template slot-scope="sScope">
                      <template v-if="editMode">
                        <el-select v-model="sScope.row.taxRate" placeholder="请选择税率" style="width: 90%" :key="'tr' + timeStamp" @change="unTaxRateChange($event, sScope.row)">
                          <el-option v-for="item in TaxRateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </template>
                      <template v-else>{{ sScope.row.taxRate }}%</template>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="税额" align="center" min-width="140" prop="taxAmount" :formatter="toDecimal4" />
                  <el-table-column show-overflow-tooltip label="开票数量/金额" align="center" min-width="200">
                    <template slot-scope="sScope">
                      <template v-if="editMode">
                        <SeparateInput class="billing" :left="sScope.row.billNumber" :right="sScope.row.billAmount" :key="'si' + timeStamp" :leftOption="{
                            min: 0,
                            max: sScope.row.number,
                            precision: 2,
                            placeholder: '请填写开票数量',
                          }" :rightOption="{
                            precision: 4,
                            placeholder: '自动带出开票金额',
                            disabled: true,
                          }" :autoCalculation="false" style="width: 90%" @change="
                            (left, right) =>
                              billNumberChange(
                                left,
                                right,
                                sScope.row,
                                scope2.row
                              )
                          "></SeparateInput>
                      </template>
                      <template v-else>
                        {{ toDecimal2("", "", sScope.row.billNumber) }}/{{
                          toDecimalNo4("", "", sScope.row.billAmount)
                        }}
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="待开票数量/金额" align="center" min-width="140">
                    <template slot-scope="sScope">
                      {{ toDecimal2("", "", sScope.row.unBillNumber) }}/{{
                        toDecimalNo4("", "", sScope.row.unBillAmount)
                      }}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="单号" align="center" min-width="180" prop="no" />
            <el-table-column show-overflow-tooltip label="库房/科室" align="center" min-width="130" prop="fixedAssetName">
              <template slot-scope="scope">
                {{ scope.row.warehouseName }}{{ scope.row.stockDeptName }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="创建时间" align="center" min-width="130" prop="createdTime">
              <template slot-scope="scope">
                <div>
                  {{
                    parseTime(new Date(scope.row.createdTime), "{y}:{m}:{d}")
                  }}
                </div>
                <div>
                  {{
                    parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}")
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="数量" align="center" min-width="140" prop="billNumber" :formatter="toDecimal2" />
            <el-table-column show-overflow-tooltip label="待开票数量" align="center" min-width="140" prop="unBillNumber" :formatter="toDecimal2" />
            <el-table-column show-overflow-tooltip label="金额" align="center" min-width="140" prop="billAmount" :formatter="toDecimal4" />
            <el-table-column show-overflow-tooltip label="待开票金额" align="center" min-width="140" prop="unBillAmount" :formatter="toDecimal4" />
          </el-table>
          <div class="pagination" v-show="detailShowType == '0'">
            <el-pagination background layout="prev, pager, next" :current-page="uninvoicedQuery.pageIndex" :total="uninvoicedTotal" @current-change="changePage">
            </el-pagination>
          </div>
          <div class="pagination" v-show="detailShowType == '1'">
            <el-pagination background layout="prev, pager, next" :current-page="ininvoicedQuery.pageIndex" :total="ininvoicedTotal" @current-change="changePage">
            </el-pagination>
          </div>
        </div>
        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">付款信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="已付款金额" prop="payAmount">
                <el-input-number v-model="form.payAmount" disabled :min="0" :precision="4" :controls="false" style="width: 90%" placeholder="自动带出已付款金额"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="未付款金额" prop="unPayAmount">
                <el-input-number v-model="form.unPayAmount" disabled :min="0" :precision="4" :controls="false" style="width: 90%" placeholder="自动带出未付款金额"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款状态" prop="payState">
                <el-select disabled v-model="form.payState" style="width: 90%" placeholder="自动带出付款状态">
                  <el-option v-for="item in buyOrSale
                      ? CollectionStateOptions
                      : PayStateOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetPurchaseInvoiceById,
  RejectPurchaseInvoice,
  SavePurchaseInvoice,
  GetUninvoicedNoInfo,
  GetManufacturerInfos,
} from "@/api";
import {
  InvoiceTypeOptions,
  BillTypeOptions,
  BillTypeOptions2,
  BillingDetailsTypeOptions,
  PayStateOptions,
  CollectionStateOptions,
  TaxRateOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import SeparateInput from "@/components/separate-input";
import UploadFileList from "@/components/upload-file-list";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    SeparateInput,
    UploadFileList,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "购入发票",
      reject: RejectPurchaseInvoice,
      form: {
        relationNoIds: "",
        relationNoArr: [],
        relationNoInfos: [],
        totalNumber: 0,
        totalAmount: 0,
        unTotalNumber: 0,
        unTotalAmount: 0,
      },
      rules: {
        no: [{ required: true, message: "发票号码不能为空", trigger: "blur" }],
        billCode: [
          { required: true, message: "发票代码不能为空", trigger: "blur" },
        ],
        ownerDeptName: [
          { required: true, message: "所属科室不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "发票类型不能为空", trigger: "blur" },
        ],
        category: [
          { required: true, message: "单据类型不能为空", trigger: "blur" },
        ],
        relationNoArr: [
          { required: true, message: "关联单号不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "开票日期不能为空", trigger: "blur" },
        ],
        billUserName: [
          { required: true, message: "开票人不能为空", trigger: "blur" },
        ],
        billDeptName: [
          { required: true, message: "所属科室不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      reject: RejectPurchaseInvoice,
      InvoiceTypeOptions: InvoiceTypeOptions,
      BillTypeOptions: BillTypeOptions,
      BillTypeOptions2: BillTypeOptions2,
      BillingDetailsTypeOptions: BillingDetailsTypeOptions,
      PayStateOptions: PayStateOptions,
      CollectionStateOptions: CollectionStateOptions,
      TaxRateOptions: TaxRateOptions,

      detailShowType: "0",
      ManufacturerInfos: [],

      // 子表
      parentSelection: [],
      sonSelection: [],
      _parentSelection: [],
      _sonSelection: [],
      inParentSelection: [],
      inSonSelection: [],
      _inSonSelection: [],
      // 查询条件
      uninvoicedQuery: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "",
        disposalMethods: [],
        dateRange: [],
        startDate: "",
        endDate: "",
      },
      // 查询条件
      ininvoicedQuery: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        dateRange: [],
        startDate: "",
        endDate: "",
      },
      // 列表数据
      uninvoicedData: [],
      ininvoicedData: [],
      // 列表总数
      uninvoicedTotal: 0,
      ininvoicedTotal: 0,
      timeStamp: "",
      buyOrSale: 0,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.buyOrSale) {
        switch (query.buyOrSale) {
          case "0":
            this.typeName = "购入发票";
            this.buyOrSale = 0;
            break;
          case "1":
            this.typeName = "售出发票";
            this.buyOrSale = 1;
            break;
        }
      }
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetPurchaseInvoiceById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        // if (!this.editMode) {
        this.detailShowType = "1";
        // }
        this.getShowDetailsData();
      });
    },
    Query (isClear = false) {
      if (isClear) {
        this._parentSelection = [];
        this._sonSelection = [];
        this.parentSelection = [];
        this.sonSelection = [];
        this.form.details = [];
        this.inParentSelection = [];
        this.inSonSelection = [];
        this._inSonSelection = [];
      }
      this.uninvoicedQuery.manufacturerInfoId = this.form.manufacturerInfoId;
      this.uninvoicedQuery.manufacturerInfoType = this.form.manufacturerInfoType;
      this.GetUninvoiced();
    },
    async GetUninvoiced () {
      await GetUninvoicedNoInfo(this.uninvoicedQuery).then((res) => {
        this.uninvoicedData = res.returnData.data;
        this.uninvoicedData.forEach((t) => {
          t.relationOrderId = t.id;
          t.relationOrderNo = t.no;
          t.details.forEach((l) => {
            l.taxRate = 13;
            // l.taxAmount = this.getFloat(
            //   ((l.amount / (1 + l.taxRate / 100)) * l.taxRate) / 100,
            //   4
            // );
          });
        });
        this.uninvoicedTotal = res.returnData.totalCount;
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        no: null,
        billCode: null,
        createdUserName: this.userInfo.name,
        deptName: null,
        type: null,
        category: null,
        totalNumber: null,
        totalAmount: null,
        unTotalAmount: null,
        unTotalNumber: null,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d} {h}:{m}:{s}"),
        date: null,
        fileInfos: [],
        details: [],

        payState: 0,
        payAmount: 0,
        unPayAmount: 0,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.buyOrSale = this.buyOrSale;
        SavePurchaseInvoice(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    userChange (val) {
      this.form.billUserId = val;
    },
    deptChange (val) {
      this.form.ownerDept = val;
    },
    billDeptChange (val) {
      this.form.billDeptId = val;
    },
    manufacturerChange (val) {
      if (val) {
        this.form.manufacturerInfoId = val.split("-")[1];
        this.form.manufacturerInfoType = val.split("-")[0];
      } else {
        this.form.manufacturerInfoId = "";
        this.form.manufacturerInfoType = "";
      }
      this.Query();
    },
    categoryChange (e) {
      this.uninvoicedQuery.category = e;
      this.Query(true);
    },
    disabledDateFun (v) {
      return v.getTime() > new Date().getTime();
    },
    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
    /**
     * 开票明细类型选择
     */
    handleClick (e) {
      switch (this.detailShowType) {
        case "0":
          // 待选开票单号
          this.uninvoicedQuery.pageIndex = 1;
          // this.GetUninvoiced();
          break;
        case "1":
          // 已选开票单号
          this.ininvoicedQuery.pageIndex = 1;
          this.getShowDetailsData();
          break;
      }
    },
    /**
     * 明细筛选日期选择
     */
    dateChange (e) {
      if (e) {
        this.uninvoicedQuery.startDate = this.parseTime(
          new Date(e[0]),
          "{y}-{m}-{d}"
        );
        this.uninvoicedQuery.endDate = this.parseTime(
          new Date(e[1]),
          "{y}-{m}-{d}"
        );
      } else {
        this.uninvoicedQuery.startDate = "";
        this.uninvoicedQuery.endDate = "";
      }
    },
    // 改变当前页
    changePage (val) {
      switch (this.detailShowType) {
        case "0":
          // 待选开票单号
          this.$set(this.uninvoicedQuery, "pageIndex", val);
          break;
        case "1":
          // 已选开票单号
          this.$set(this.ininvoicedQuery, "pageIndex", val);
          this.getShowDetailsData();
          break;
      }
    },
    // -------------------------待选--------------------------------
    /**
     * 待开票一级表选中触发（未使用）
     */
    handleChildSelectionChange (selection) {
      return;
      let parent = null;
      let sData = null;
      selection.forEach((l) => {
        parent = JSON.parse(JSON.stringify(l));
        parent.details = [];
        if (!this.keyInArray(this.parentSelection, parent, "id", "id")) {
          this.parentSelection.push(parent);
        }
        sData = this.$refs["towList" + l.id].data;
        for (let i = 0; i < sData.length; i++) {
          if (this.sonSelection.indexOf(sData[i]) == -1) {
            this.sonSelection.push(sData[i]);
          }
          this.$refs["towList" + l.id].toggleRowSelection(sData[i], true);
        }
        // this.$refs["towList" + l.id].clearSelection();
        // this.$refs["towList" + l.id].toggleAllSelection();
      });
      // this.timeStamp = new Date().valueOf();
    },
    /**
     * 待选开票单号子表选中行（未使用）
     * @selection 选中的行
     * @prow 父行
     */
    handleChildSonSelectionChange (selection, prow) {
      return;
      window.console.log("子表选择了");
      let parent = JSON.parse(JSON.stringify(prow));
      parent.details = [];
      if (selection.length > 0) {
        // 二级表有选中时
        if (!this.keyInArray(this.parentSelection, parent, "id", "id")) {
          // 还没有加入，就加入
          this.parentSelection.push(parent);
          this.$refs.unTable.toggleRowSelection(prow, true);
        }
      } else {
        // 二级表无选中时
        if (this.keyInArray(this.parentSelection, parent, "id", "id")) {
          let item = this.parentSelection.find((t) => t.id == parent.id);
          // 已经存在就移除
          this.remove(this.parentSelection, item);
          this.$refs.unTable.toggleRowSelection(prow, false);
        }
      }
      let isHave = true;
      let item = null;
      while (isHave) {
        // 先清空所有已选的数据
        item = this.sonSelection.find((t) => t.parentId == parent.id);
        if (item) {
          this.remove(this.sonSelection, item);
        } else {
          isHave = false;
        }
      }
      selection.forEach((t) => {
        this.sonSelection.push(t);
      });
      // this.AddOrDelete();
    },
    /**
     * 待开票一级表全选
     */
    handleChildSelectAll (selection) {
      this.parentSelection = []; // 先清空已选的项
      this.sonSelection = [];
      let parent = null;
      let sData = null;
      if (selection.length == 0) {
        this.uninvoicedData.forEach((t) => {
          this.$refs["towList" + t.id].clearSelection();
        });
        return;
      }
      selection.forEach((l) => {
        parent = JSON.parse(JSON.stringify(l));
        parent.details = [];
        this.parentSelection.push(parent);
        sData = this.$refs["towList" + l.id].data;
        l.details.forEach((t) => {
          if (this.sonSelection.indexOf(t) == -1) {
            this.sonSelection.push(t);
          }
          this.$refs["towList" + l.id].toggleRowSelection(t, true);
        });
      });
    },
    /**
     * 待开票一级表选一行
     */
    handleChildRowChange (selection, row) {
      let parent = JSON.parse(JSON.stringify(row));
      if (selection.indexOf(row) == -1) {
        // 取消选择
        parent.details = [];
        let item = this.parentSelection.find((t) => t.id == row.id);
        if (item) {
          // 待选里选择的单号中有就删除
          this.remove(this.parentSelection, item);
        }
        row.details.forEach((t) => {
          let itemS = this.sonSelection.find((l) => l.id == t.id);
          if (itemS) {
            this.remove(this.sonSelection, itemS);
          }
        });
        this.$refs["towList" + row.id].clearSelection(); // 清除子表选中
      } else {
        // 选中
        let item = this.parentSelection.find((t) => t.id == row.id);
        if (!item) {
          this.parentSelection.push(row);
        }
        row.details.forEach((t) => {
          let itemS = this.sonSelection.find((l) => l.id == t.id);
          if (!itemS) {
            this.sonSelection.push(t);
          }
        });
        this.$refs["towList" + row.id].clearSelection();
        this.$refs["towList" + row.id].toggleAllSelection();
      }
      // this.timeStamp = new Date().valueOf();
      // this.AddOrDelete();
    },
    /**
     * 待开票子表全选
     */
    handleSonChildSelectAll (selection, prow) {
      this.handleSonChildRowChange(selection, prow);
    },
    /**
     * 待选开票单号子表选一行
     */
    handleSonChildRowChange (selection, prow) {
      // window.console.log(selection, prow);
      let parent = JSON.parse(JSON.stringify(prow));
      parent.details = [];
      if (selection.length > 0) {
        // 二级表选中时
        if (!this.keyInArray(this.parentSelection, parent, "id", "id")) {
          // 一级表是否选中
          // 还没有加入，就加入
          this.parentSelection.push(parent);
          this.$refs.unTable.toggleRowSelection(prow, true);
        }
      } else {
        // 二级表无选中时
        if (this.keyInArray(this.parentSelection, parent, "id", "id")) {
          // 一级表是否选中
          // 已经存在就移除
          let item = this.parentSelection.find((t) => t.id == parent.id);
          this.remove(this.parentSelection, item);
          this.$refs.unTable.toggleRowSelection(prow, false);
        }
      }
      let isHave = true;
      let item = null;
      while (isHave) {
        // 先清空所有已选的数据
        item = this.sonSelection.find((t) => t.parentId == parent.id);
        if (item) {
          this.remove(this.sonSelection, item);
        } else {
          isHave = false;
        }
      }
      selection.forEach((t) => {
        this.sonSelection.push(t);
      });
    },
    // -------------------------已选--------------------------------
    /**
     * 已选开票单号选中行（未使用）
     */
    handleChildSelectionChangeS (selection) {
      return;
      let parent = null;
      selection.forEach((l) => {
        parent = JSON.parse(JSON.stringify(l));
        parent.details = [];
        if (!this.keyInArray(this.inParentSelection, parent, "id", "id")) {
          this.inParentSelection.push(parent);
        }
        l.details.forEach((t) => {
          if (this.inSonSelection.indexOf(t) == -1) {
            this.inSonSelection.push(t);
          }
        });
      });
    },
    /**
     * 已选选开票单号子表选中行（未使用）
     * @selection 选中的行
     * @prow 父行
     */
    handleChildSonSelectionChangeS (selection, prow) {
      return;
      let parent = JSON.parse(JSON.stringify(prow));
      parent.details = [];
      if (selection.length > 0) {
        // 二级表有选中时
        if (!this.keyInArray(this.inParentSelection, parent, "id", "id")) {
          // 还没有加入，就加入
          this.inParentSelection.push(parent);
          this.$refs.inTable.toggleRowSelection(prow, true);
        }
      } else {
        // 二级表无选中时
        if (this.keyInArray(this.inParentSelection, parent, "id", "id")) {
          let item = this.inParentSelection.find((t) => t.id == parent.id);
          // 已经存在就移除
          this.remove(this.inParentSelection, item);
          this.$refs.inTable.toggleRowSelection(prow, false);
        }
      }
      let isHave = true;
      let item = null;
      while (isHave) {
        // 先清空所有已选的数据
        item = this.inSonSelection.find((t) => t.parentId == parent.id);
        if (item) {
          this.remove(this.inSonSelection, item);
        } else {
          isHave = false;
        }
      }
      selection.forEach((t) => {
        this.inSonSelection.push(t);
      });
    },
    /**
     * 已选开票一级表全选
     */
    handleChildSelectAllS (selection) {
      this.inParentSelection = []; // 先清空已选的项
      this.inSonSelection = [];
      let parent = null;
      let sData = null;
      if (selection.length == 0) {
        this.ininvoicedData.forEach((t) => {
          this.$refs["towList2" + t.id].clearSelection();
        });
        return;
      }
      selection.forEach((l) => {
        parent = JSON.parse(JSON.stringify(l));
        parent.details = [];
        this.inParentSelection.push(parent);
        sData = this.$refs["towList2" + l.id].data;
        l.details.forEach((t) => {
          if (this.inSonSelection.indexOf(t) == -1) {
            this.inSonSelection.push(t);
          }
          this.$refs["towList2" + l.id].toggleRowSelection(t, true);
        });
      });
    },
    /**
     * 已开票一级表选一行
     */
    handleChildRowChangeS (selection, row) {
      // if (selection.indexOf(row) == -1) {
      //   // 取消选择
      //   let parent = JSON.parse(JSON.stringify(row));
      //   parent.details = [];
      //   let item = this.inParentSelection.find((t) => t.id == row.id);
      //   if (item) {
      //     // 待选里选择的单号中有就删除
      //     this.remove(this.inParentSelection, item);
      //     row.details.forEach((t) => {
      //       let itemS = this.inSonSelection.find((l) => l.id == t.id);
      //       if (itemS) {
      //         this.remove(this.inSonSelection, itemS);
      //       }
      //     });
      //   }
      // }

      let parent = JSON.parse(JSON.stringify(row));
      if (selection.indexOf(row) == -1) {
        // 取消选择
        parent.details = [];
        let item = this.inParentSelection.find((t) => t.id == row.id);
        if (item) {
          // 待选里选择的单号中有就删除
          this.remove(this.inParentSelection, item);
        }
        row.details.forEach((t) => {
          let itemS = this.inSonSelection.find((l) => l.id == t.id);
          if (itemS) {
            this.remove(this.inSonSelection, itemS);
          }
        });
        this.$refs["towList2" + row.id].clearSelection(); // 清除子表选中
      } else {
        // 选中
        let item = this.inParentSelection.find((t) => t.id == row.id);
        if (!item) {
          this.inParentSelection.push(row);
        }
        row.details.forEach((t) => {
          let itemS = this.inSonSelection.find((l) => l.id == t.id);
          if (!itemS) {
            this.inSonSelection.push(t);
          }
        });
        this.$refs["towList2" + row.id].clearSelection();
        this.$refs["towList2" + row.id].toggleAllSelection();
      }
    },
    /**
     * 已开票子表全选
     */
    handleSonChildSelectAllS (selection, prow) {
      this.handleSonChildRowChangeS(selection, prow);
    },
    /**
     * 已开票子表选一行
     */
    handleSonChildRowChangeS (selection, prow) {
      let parent = JSON.parse(JSON.stringify(prow));
      parent.details = [];
      if (selection.length > 0) {
        // 二级表选中时
        if (!this.keyInArray(this.inParentSelection, parent, "id", "id")) {
          // 一级表是否选中
          // 还没有加入，就加入
          this.inParentSelection.push(parent);
          this.$refs.inTable.toggleRowSelection(prow, true);
        }
      } else {
        // 二级表无选中时
        if (this.keyInArray(this.inParentSelection, parent, "id", "id")) {
          // 一级表是否选中
          // 已经存在就移除
          let item = this.inParentSelection.find((t) => t.id == parent.id);
          this.remove(this.inParentSelection, item);
          this.$refs.inTable.toggleRowSelection(prow, false);
        }
      }
      let isHave = true;
      let item = null;
      while (isHave) {
        // 先清空所有已选的数据
        item = this.inSonSelection.find((t) => t.parentId == parent.id);
        if (item) {
          this.remove(this.inSonSelection, item);
        } else {
          isHave = false;
        }
      }
      selection.forEach((t) => {
        this.inSonSelection.push(t);
      });
    },
    // -------------------------------------------------------------
    /**
     * 组装已选开票单号数组
     * @pData 父数据
     * @sData 子数据
     */
    assembleInDetailsData (pData, sData) {
      let _pData = JSON.parse(JSON.stringify(pData));
      let _sData = JSON.parse(JSON.stringify(sData));
      this._parentSelection.forEach((item) => {
        // 把缓存的父选中项加上
        if (!_pData.find((t) => t.id == item.id)) {
          _pData.push(item);
        }
      });
      this._parentSelection = JSON.parse(JSON.stringify(_pData));

      this._sonSelection.forEach((item) => {
        if (!_sData.find((t) => t.id == item.id)) {
          _sData.push(item);
        }
      });

      this._sonSelection = JSON.parse(JSON.stringify(_sData));

      this._inSonSelection = JSON.parse(JSON.stringify(_sData));

      _sData.forEach((t) => {
        let item = _pData.find((l) => l.id == t.parentId);
        if (item) {
          if (!this.keyInArray(item.details, t, "id", "id")) {
            item.details.push(t);
          }
        }
      });
      this.ininvoicedTotal = _pData.length;
      return _pData;
    },
    /**
     * 重新组装删除后已选开篇单号数组
     * @pData 父数据
     * @sData 子数据
     */
    assembleUnDetailsData (pData, sData) {
      this._inSonSelection = [];
      let nowData = JSON.parse(JSON.stringify(this.form.details));
      nowData.forEach((t) => {
        // 循环当前的列表
        sData.forEach((l) => {
          // 循环删除的子表
          let item = t.details.find((m) => m.id == l.id);
          if (item) {
            // 当前表子表存在删除的子表数据就删除
            this.remove(t.details, item);
          }
        });
      });
      let isHave = true;
      while (isHave) {
        let item = nowData.find(
          (t) => t.details == null || t.details.length == 0
        );
        if (item) {
          this.remove(nowData, item);
        } else {
          isHave = false;
        }
      }
      nowData.forEach((t) => {
        t.details.forEach((n) => {
          this._inSonSelection.push(n);
        });
      });
      return nowData;
    },
    /**
     * 重置未选单号的选中
     */
    async setUnDetailDataSelected () {
      this._parentSelection = [];
      this._sonSelection = [];
      this.parentSelection = [];
      this.sonSelection = [];
      await this.GetUninvoiced();
      let data = JSON.parse(JSON.stringify(this.form.details));
      data.forEach((item) => {
        let pdata = this.uninvoicedData.find((t) => t.id == item.id);
        if (pdata) {
          this.$refs.unTable.toggleRowSelection(pdata, true);
          item.details.forEach((itemS) => {
            let sdata = pdata.details.find((t) => t.id == itemS.id);
            if (sdata) {
              this.$refs["towList" + item.id].toggleRowSelection(sdata, true);
            }
          });
        }
        this.handleSonChildRowChange(
          JSON.parse(JSON.stringify(item.details)),
          JSON.parse(JSON.stringify(item))
        );
      });
    },
    /**
     * 新增已选或删除已选
     */
    AddOrDelete () {
      switch (this.detailShowType) {
        case "0":
          // 添加开票单号
          this.$set(
            this.form,
            "details",
            this.assembleInDetailsData(this.parentSelection, this.sonSelection)
          );
          let totalNumber = 0,
            totalAmount = 0,
            unTotalNumber = 0,
            unTotalAmount = 0,
            currBillNumber = 0,
            currBillAmount = 0;
          this.form.details.forEach((t) => {
            currBillNumber = 0;
            currBillAmount = 0;
            t.details.forEach((l) => {
              currBillNumber += l.billNumber;
              currBillAmount += l.billAmount;
              totalNumber += l.billNumber;
              totalAmount += l.billAmount;
            });
            t.CurrBillNumber = currBillNumber;
            t.CurrBillAmount = currBillAmount;
            unTotalNumber += t.unBillNumber;
            unTotalAmount += t.unBillAmount;
          });
          this.form.totalNumber = totalNumber;
          this.form.totalAmount = totalAmount;
          this.form.unTotalNumber = unTotalNumber;
          this.form.unTotalAmount = unTotalAmount;
          break;
        case "1":
          // 删除开票单号
          this.$set(
            this.form,
            "details",
            this.assembleUnDetailsData(
              this.inParentSelection,
              this.inSonSelection
            )
          );
          this.setUnDetailDataSelected();
          break;
      }
      this.getShowDetailsData();
    },
    /**
     * 明细表是否可再选择
     */
    pSelectable (row, index) {
      let item = this.form.details.find((l) => l.id == row.id);
      if (item) {
        if (item.details.length == row.details.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    /**
     * 明细表子表是否可再选择
     */
    sSelectable (row, index) {
      let item = this._inSonSelection.find((t) => t.id == row.id);
      if (item) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 获取需要显示的details内容
     */
    getShowDetailsData () {
      this.ininvoicedData = this.form.details.slice(
        (this.ininvoicedQuery.pageIndex - 1) * this.ininvoicedQuery.pageSize,
        this.ininvoicedQuery.pageIndex * this.ininvoicedQuery.pageSize
      );
    },
    unTaxRateChange (e, row) {
      row.taxAmount = this.getFloat(
        (row.billAmount / (1 + e / 100)) * (e / 100),
        4
      );
      this.timeStamp = new Date().valueOf();
    },
    billNumberChange (left, right, row, prow) {
      row.billNumber = left;
      row.billAmount = left * row.price;
      if (row.billAmount > row.unBillAmount) {
        row.billAmount = row.unBillAmount > 0 ? row.unBillAmount : 0;
      }
      // row.unBillNumber = row.number - left;
      // row.unBillAmount = row.unBillNumber * row.price;
      let amount = 0,
        number = 0;
      prow.details.forEach((t) => {
        amount += t.unBillAmount;
        number += t.unBillNumber;
      });
      prow.unBillAmount = amount;
      prow.unBillNumber = number;
      let totalNumber = 0,
        totalAmount = 0,
        unTotalNumber = 0,
        unTotalAmount = 0,
        currBillNumber = 0,
        currBillAmount = 0;
      this.form.details.forEach((t) => {
        currBillNumber = 0;
        currBillAmount = 0;
        t.details.forEach((l) => {
          currBillNumber += l.billNumber;
          currBillAmount += l.billAmount;
          totalNumber += l.billNumber;
          totalAmount += l.billAmount;
        });
        t.CurrBillNumber = currBillNumber;
        t.CurrBillAmount = currBillAmount;
        unTotalNumber += t.unBillNumber;
        unTotalAmount += t.unBillAmount;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
      this.form.unTotalNumber = unTotalNumber;
      this.form.unTotalAmount = unTotalAmount;
      this.form.unPayAmount = this.form.totalAmount;

      // 算税额
      row.taxAmount = this.getFloat(
        (row.billAmount / (1 + row.taxRate / 100)) * (row.taxRate / 100),
        4
      );
      this.timeStamp = new Date().valueOf();
    },
    getRowClass (row, rowIndex) {
      let data = row.row;
      let res = [];
      if (data.details && data.details.length > 0) {
        res.push("row-expand-has");
      } else {
        res.push("row-expand-unhas");
      }
      return res;
    },
    toDecimal4 (row, column, cellValue, index) {
      return "￥" + this.toDecimal(cellValue, 4);
    },
    toDecimalNo4 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 4);
    },
    toDecimal2 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 2);
    },
    getFloat (num, n) {
      n = n ? parseInt(n) : 0;
      if (n <= 0) {
        return Math.round(num);
      }
      num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
      num = Number(num).toFixed(n); //补足位数
      return num;
    },
    GetManufacturer (keyWord) {
      GetManufacturerInfos({
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 10000,
      }).then((res) => {
        this.ManufacturerInfos = res.returnData.data;
      });
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getWarehouses();
    this.GetUninvoiced();
    this.getDepts();
    this.getUsers();
    this.GetManufacturer();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.detail-header {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px 10px;
  .right {
    display: flex;
    align-items: center;
    .date-range-div {
      height: 39px;
      margin-left: 30px;
      font-size: 12px;
      border-bottom: 1px solid rgba(40, 106, 180, 0.5);
      box-sizing: border-box;
      line-height: 40px;
      /deep/.el-input__inner {
        border: 0;
      }
      /deep/.el-range__icon {
        display: none;
      }
    }
    .search {
      margin-left: 10px;
      padding-left: 10px;
      display: flex;
      align-items: center;
      background: #e4e4e4;
      line-height: 32px;
      margin-right: 10px;
      border-radius: 2px;
      .search-input {
        height: 34px;
        background-color: #e4e4e4;
        border: none;
        outline: none;
        font-size: 14px;
      }
      .el-icon-search {
        cursor: pointer;
        color: #bbbbbb;
        font-size: 12px;
      }
    }
  }
}
.two-list {
  margin-left: 3%;
  width: 97%;
  /deep/.el-table__body-wrapper {
    overflow-y: auto;
    max-height: 400px;
  }
}
.pagination {
  padding-top: 10px;
  background: transparent;
}
.two-list .separete {
  height: auto;
}
</style>
